document.addEventListener('DOMContentLoaded', () => {
  const likeContainers = document.querySelectorAll('.post-interaction');

  likeContainers.forEach(container => {
    const button = container.querySelector('.post-interaction__like-button');
    const count = container.querySelector('.post-interaction__like-count');
    const postId = container.dataset.postId;

    if (!button || !count || !postId) return;

    if (localStorage.getItem(`liked_${postId}`)) {
      button.classList.add('liked');
    }

    button.addEventListener('click', () => {
      if (localStorage.getItem(`liked_${postId}`)) return;

      fetch('/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          action: 'md_handle_post_like',
          post_id: postId,
          nonce: window.mdAjax?.nonce || '',
        }),
      })
      .then(res => res.json())
      .then(data => {
        console.log('Respuesta AJAX:', data);
        if (data.success) {
          count.textContent = `${data.data.new_likes}`;
          button.classList.add('liked');
          localStorage.setItem(`liked_${postId}`, true);
        } else {
          console.error('Error:', data.message);
        }
      })
      .catch(err => console.error('Fetch error:', err));
    });
  });
});
